import React from 'react';
import { firebaseApp } from '../firebase/firebase';
import { User } from 'firebase';
import { RiderForm } from './rider-form';

export function NewRider({ user }: { user: User }) {
  return (
    <RiderForm
      rider={{ name: '', email: '' }}
      onSave={async rider => {
        await firebaseApp
          .firestore()
          .collection(`users/${user.uid}/riders`)
          .add(rider);
      }}
    />
  );
}
